import config from '../config';

// Map the Azure AD groups to roles
const ADMIN_GROUP_ID = config.adminGroupId;
const REQUESTOR_GROUP_ID = config.requestorGroupId;

class RoleService {
  getUserRole(groupIds = []) {
    console.log("DEBUG - Checking role for user with groups:", groupIds);
    console.log("DEBUG - Looking for admin group:", ADMIN_GROUP_ID);
    console.log("DEBUG - Looking for requestor group:", REQUESTOR_GROUP_ID);
    
    // Direct string comparison for simplicity and reliability
    const isAdmin = groupIds.includes(ADMIN_GROUP_ID);
    const isRequestor = groupIds.includes(REQUESTOR_GROUP_ID) || isAdmin;
    
    console.log(`DEBUG - Is admin: ${isAdmin}`);
    console.log(`DEBUG - Is requestor: ${isRequestor}`);
    
    // Determine role name - default is Guest if no roles match
    let roleName = "Guest";
    
    if (isAdmin) roleName = "ODM Admin";
    else if (isRequestor) roleName = "ODM Requestor";
    
    console.log(`DEBUG - Final role determined: ${roleName}`);
    
    return {
      isAdmin,
      isRequestor,
      roleName,
      timestamp: new Date().getTime()
    };
  }
  
  clearRoleCache() {
    localStorage.removeItem('odm_user_role');
    console.log("DEBUG - Role cache cleared");
    return true;
  }
  
  // Other methods remain the same...
  cacheUserRole(role, email) {
    if (!role || !email) return;
    
    localStorage.setItem('odm_user_role', JSON.stringify({
      ...role,
      email,
      expires: new Date().getTime() + (4 * 60 * 60 * 1000)
    }));
  }
  
  getCachedRole(email) {
    try {
      const cached = JSON.parse(localStorage.getItem('odm_user_role'));
      if (!cached) return null;
      
      if (cached.email === email && cached.expires > new Date().getTime()) {
        return cached;
      }
      
      localStorage.removeItem('odm_user_role');
      return null;
    } catch (e) {
      console.error("Error reading cached role:", e);
      return null;
    }
  }
}

export const roleService = new RoleService();
export default roleService;